<template>
	<app-content class="h-panel">
		<Loading text="数据加载中..." :loading="loading"></Loading>
		<div class="h-panel-bar">
			<span class="h-panel-title">{{ report ? report.name : '业务活动表' }}&nbsp;</span>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left margin-top">
			<Cell>
				<account-date-choose v-model="accountDate"/>
			</Cell>
			<Cell class="label">核算组织：</Cell>
			<Cell>
				<TreePicker :option="orgOption" style="display: inline-block;min-width: 150px"
				            ref="orgTreePicker" v-model="orgId"></TreePicker>
			</Cell>
			<Cell>
				<Button :disabled="!report" :loading="loading" color="primary" @click="doSearch">查询</Button>
			</Cell>
		</Row>
		<div class="h-panel-body" v-if="report">
			<Table class="small-td" :datas="templateItems" selectRow border>
				<TableItem title="名称">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{ data.title }}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{ data.isClassified ? '' : data.lineNum > -1 ? data.lineNum : '' }}
					</template>
				</TableItem>
				<TableItem title="本年累计金额" align="right">
					<template slot-scope="{data}">
						{{ reportData[data.id] ? reportData[data.id].currentYearAmount : '' | numFormat }}
					</template>
				</TableItem>
				<TableItem title="本期金额" align="right">
					<template slot-scope="{data}">
						{{ reportData[data.id] ? reportData[data.id].currentPeriodAmount : '' | numFormat }}
					</template>
				</TableItem>
			</Table>
		</div>
	</app-content>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: "BusinessActivityStatement",
	data() {
		return {
			orgOption: {
				keyName: 'id',
				parentName: 'parentId',
				titleName: 'title',
				dataMode: 'list',
				datas: []
			},
			report: null,
			reportData: {},
			accountDate: null,
			orgId: null,
			loading: false
		}
	},
	computed: {
		...mapState(['User', 'orgDatas', 'currentOrgId']),
		templateItems() {
			return this.report ? this.report.items : [];
		}
	},
	methods: {
		doSearch() {
			this.loadReport();
		},
		loadReport() {
			// 民间非营利组织账套的 lrb 模板即业务活动表；其余账套 lrb 为利润表
			Api.report.template.list().then(({data}) => {
				const tpl = data.find(t => t.templateKey === 'lrb');
				if (!tpl) {
					this.loading = false;
					this.$Message.success('未找到业务活动表模板(templateKey=lrb)');
					return;
				}
				Api.report.template.load(tpl.id).then(({data: rpt}) => {
					this.report = rpt;
					this.$nextTick(this.loadReportData);
				});
			});
		},
		loadReportData() {
			if (this.accountDate) {
				this.loading = true;
				Api.report.view(this.report.id, {accountDate: this.accountDate, orgId: this.orgId, dimension: 'MONTH'}).then(({data}) => {
					this.reportData = data;
				}).finally(() => this.loading = false);
			} else {
				this.loading = false;
			}
		}
	},
	mounted() {
		if (this.currentOrgId) {
			this.orgId = this.currentOrgId;
		}
		if (this.orgDatas && this.orgDatas.length) {
			this.orgOption.datas = this.orgDatas.map(val => {
				return {id: val.id, name: val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId, currentAccountDate: val.currentAccountDate, enableDate: val.enableDate}
			});
		} else {
			this.$watch('orgDatas', () => {
				if (this.orgDatas && this.orgDatas.length && !this.orgOption.datas.length) {
					this.orgOption.datas = this.orgDatas.map(val => ({id: val.id, name: val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId, currentAccountDate: val.currentAccountDate, enableDate: val.enableDate}));
				}
			}, {immediate: true});
		}
		this.loadReport();
	}
}
</script>

<style scoped>
div.font-bold {
	font-size: 14px;
}
</style>
